var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 1.875H20.0625V0H18.1875V1.875H5.8125V0H3.9375V1.875H2.8125C1.26169 1.875 0 3.13669 0 4.6875V21.1875C0 22.7383 1.26169 24 2.8125 24H16.1487L24 15.8468V4.6875C24 3.13669 22.7383 1.875 21.1875 1.875ZM16.6875 20.7374V17.3438C16.6875 16.8268 17.1081 16.4062 17.625 16.4062H20.8582L16.6875 20.7374ZM22.125 14.5312H17.625C16.0742 14.5312 14.8125 15.7929 14.8125 17.3438V22.125H2.8125C2.29556 22.125 1.875 21.7044 1.875 21.1875V8.8125H22.125V14.5312ZM22.125 6.9375H1.875V4.6875C1.875 4.17056 2.29556 3.75 2.8125 3.75H3.9375V5.625H5.8125V3.75H18.1875V5.625H20.0625V3.75H21.1875C21.7044 3.75 22.125 4.17056 22.125 4.6875V6.9375Z",
    fill: "#3C38CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.9c1da4af14ba2e9851de5bc3baaa2e1b.svg";
export { ForwardRef as ReactComponent };